import React, { Fragment, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'
import CloverLayout from './Clover'
import RegisterLayout from './Register'

const Layouts = {
  public: PublicLayout,
  account: AuthLayout,
  main: MainLayout,
  clover: CloverLayout,
  register: RegisterLayout,
}

const publicPaths = ['/integrations/shopify', '/shopify/register']

const Layout = ({ children }) => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/' || publicPaths.includes(pathname)) {
      return 'public'
    }
    if (/^\/clover(?=\/|$)/i.test(pathname)) {
      return 'clover'
    }
    if (/^\/onboard(?=\/|$)/i.test(pathname)) {
      return 'register'
    }
    if (/^\/account(?=\/|$)/i.test(pathname)) {
      return 'account'
    }
    return 'main'
  }

  const Container = Layouts[getLayout()]

  return (
    <Fragment>
      <Helmet titleTemplate="RewardUp | %s" title="Store Portal" />
      <Container>{children}</Container>
    </Fragment>
  )
}

export default Layout
